var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define(["require", "exports", "jquery", "./context", "./querystring", "./priceFormula", "./assetPicker", "./slideSelect", "./renderCustomValance", "./attributePanel", "./favorites"], function (require, exports, $, context_1, querystring_1, priceFormula_1, assetPicker_1, slideSelect_1, renderCustomValance_1, attributePanel_1, favorites_1) {
    "use strict";
    exports.__esModule = true;
    exports.attributeName_to_queryName = {
        width: "w",
        height: "h",
        styleIndex: "s",
        productType: "p",
        windowType: "wt",
        sideWidth: "sw",
        windowWidth: "ww",
        windowHeight: "wh",
        windowLeftMargin: "ml",
        windowRightMargin: "mr",
        windowTopMargin: "mt",
        windowBottomMargin: "mb",
        panelHeading: "ph",
        valanceWidth: "vw",
        panelFabricGrade: "dfg",
        panelWidth: "dw",
        panelHeight: "dh",
        swagOrder: "so",
        tailOrder: "to",
        fabricId: "fi",
        fabricCodeName: "fc",
        fabric2Id: "fi2",
        fabric2_CodeName: "fc2",
        fabricGrade: "fg",
        fabric2Grade: "fg2",
        fabric2_for_sideTails: "f2t",
        fabric2_for_swags: "f2s",
        fabric2_for_fans: "f2f",
        fabric2_for_drapes: "f2d",
        fabric2_for_rodPocket: "f2rp",
        fabric2_for_midTails: "f2mt",
        fabric2_for_pelmet: "f2pm",
        liningFabric: "lfi",
        fabricDiscount: "fd",
        fringeColor: "frg",
        useCustomSize: "uc",
        customHeight: "ch",
        customWidth: "cw",
        skipWindowMeasurement: "sm",
        wallColor: "wc",
        customProgress: "cp",
        sheerPanel: "sp",
        sheerGrade: "spg",
        matchingFabrircId: "mfi",
        material: "fm"
    };
    var queryName_to_attributeName = {
        w: "width",
        h: "height",
        s: "styleIndex",
        p: "productType",
        wt: "windowType",
        sw: "sideWidth",
        ww: "windowWidth",
        wh: "windowHeight",
        ml: "windowLeftMargin",
        mr: "windowRightMargin",
        mt: "windowTopMargin",
        mb: "windowBottomMargin",
        ph: "panelHeading",
        vw: "valanceWidth",
        dw: "panelWidth",
        dh: "panelHeight",
        dfg: "panelFabricGrade",
        so: "swagOrder",
        to: "tailOrder",
        fi: "fabricId",
        fc: "fabricCodeName",
        fi2: "fabric2Id",
        fc2: "fabric2_CodeName",
        fg: "fabricGrade",
        fg2: "fabric2Grade",
        f2t: "fabric2_for_sideTails",
        f2s: "fabric2_for_swags",
        f2f: "fabric2_for_fans",
        f2d: "fabric2_for_drapes",
        f2rp: "fabric2_for_rodPocket",
        f2mt: "fabric2_for_midTails",
        f2pm: "fabric2_for_pelmet",
        lfi: "liningFabric",
        fd: "fabricDiscount",
        frg: "fringeColor",
        uc: "useCustomSize",
        ch: "customHeight",
        cw: "customWidth",
        sm: "skipWindowMeasurement",
        wc: "wallColor",
        cp: "customProgress",
        sp: "sheerPanel",
        spg: "sheerGrade",
        mfi: "matchingFabricId",
        fm: "material"
    };
    function replaceQuery(query) {
        var location = window.location;
        return location.protocol + "'//'" + location.host + location.pathname + querystring_1.formatQuery(query);
    }
    function updateQueryWith(query, name, val) {
        var valDefined = val || (typeof val === "number" && !isNaN(val));
        var qName = exports.attributeName_to_queryName[name]
            ? exports.attributeName_to_queryName[name]
            : name;
        if (qName == 'fd') {
            return query;
        }
        if (name != qName) {
            delete query[name];
        }
        if (!valDefined) {
            delete query[qName];
        }
        else {
            query[qName] = val;
        }
        return query;
    }
    function setHashQuery(name, val, keepBackStack) {
        var query = context_1["default"].getQuery();
        var valDefined = val || (typeof val === "number" && !isNaN(val));
        if (!name || !valDefined) {
            console.log("name and/or val not defined");
        }
        var qName = exports.attributeName_to_queryName[name]
            ? exports.attributeName_to_queryName[name]
            : name;
        if (!valDefined) {
            delete query[qName];
        }
        else {
            query[qName] = val;
        }
        var formattedQuery = querystring_1.formatQuery(query);
        if (keepBackStack || !window.history) {
            window.location.search = "?" + formattedQuery;
        }
        else {
            updateAddress(window.location.pathname, query, undefined, $("head title").text());
        }
    }
    exports.setHashQuery = setHashQuery;
    function getDropdownForAttr(name) {
        return $('input[data-attribute-name="' +
            name +
            '"],select[data-attribute-name="' +
            name +
            '"]');
    }
    function getAttributePanelForAttr(name) {
        var $anchor = name == "formulaResult"
            ? $(".product-price-sheet")
            : $('input[data-attribute-name="' + name + '"]');
        var $panel = $anchor.closest(".attribute-panel");
        if (!$panel.length) {
            $panel = $anchor.prev(".attribute-panel");
        }
        return $panel;
    }
    function setSelectVal($select, val) {
        if ($select.is(":checkbox")) {
            $select.prop("checked", val == "true");
            return true;
        }
        else if ($select.is(":radio")) {
            $select.filter("*[data-decimal='" + val + "']").prop("checked", true);
            console.log("about to return");
            return true;
        }
        else {
            var floatVal = parseFloat(val);
            if ($select.is("input:not([type='hidden'])")) {
                console.log("$select id = " + ($select.attr("id") ||
                    $select.data("attribute-name")) + " val=" + val);
                $select.val(floatVal);
                return true;
            }
            else if ($select.is("input")) {
                if (isNaN(floatVal)) {
                    console.log("$select id = " + ($select.attr("id") ||
                        $select.data("attribute-name")) + " val=" + val);
                    $select.val(val);
                }
                else {
                    $select.data("decimal", floatVal.toString());
                    var selectId = $select.attr("id");
                    var $label = $("label[for=\"windowSizeEdit_" + selectId + "\"], label[for=\"curtainSizeEdit_" + selectId + "\"]");
                    $label.find(".current").text(floatVal + "\"");
                }
            }
            var $opt = null;
            if (isNaN(floatVal)) {
                $opt = $select.find("option").filter(function (i, opt) {
                    return ($(opt)
                        .text()
                        .trim() == val);
                });
            }
            else {
                $opt = $select.find('option[data-decimal="' + floatVal + '"]');
                if (!$opt.length) {
                    $opt = $select.find("option").filter(function (i, opt) {
                        return floatVal == parseFloat($(opt).text());
                    });
                }
                if (!$opt.length) {
                    var $box = $select.closest(".slide-select");
                    slideSelect_1.setRadioSelect($box, floatVal);
                }
            }
            if ($opt) {
                $opt.prop("selected", "selected");
                return true;
            }
            return false;
        }
    }
    function getAttributesFromHash() {
        var query = context_1["default"].getQuery();
        if (!$.isEmptyObject(query)) {
            return Object.keys(query).reduce(function (cur, k) {
                var _a;
                var attrName = queryName_to_attributeName[k] || k;
                return __assign({}, cur, (_a = {}, _a[attrName] = query[k], _a));
            }, {});
        }
        return {};
    }
    exports.getAttributesFromHash = getAttributesFromHash;
    function queryToAttributes() {
        var query = context_1["default"].getQuery();
        var result = Object.keys(query)
            .filter(function (x) { return !!queryName_to_attributeName[x] || x in exports.attributeName_to_queryName; })
            .reduce(function (c, k) {
            var _a;
            return (__assign({}, c, (_a = {}, _a[queryName_to_attributeName[k] || k] = query[k], _a)));
        }, {});
        return result;
    }
    exports.queryToAttributes = queryToAttributes;
    function pickAttributes(attrs, picker) {
        var result = Object.keys(attrs).reduce(function (c, k) {
            var _a;
            return (picker(k, attrs[k]) ? __assign({}, c, (_a = {}, _a[k] = attrs[k], _a)) : c);
        }, {});
        return result;
    }
    exports.pickAttributes = pickAttributes;
    function setAttributesFromHash() {
        var query = context_1["default"].getQuery();
        if (!$.isEmptyObject(query)) {
            $.each(query, function (key, val) {
                if (key == "matchingOn") {
                    $("#matchingFabricSection").removeClass("hidden");
                    $(".second-fabric").removeClass("hidden");
                }
                if (key == 'fabricDiscount' || key == exports.attributeName_to_queryName.fabricDiscount) {
                    return;
                }
                if (key == "noWall") {
                    renderCustomValance_1.setNoWall(true);
                }
                var attributeName = queryName_to_attributeName[key]
                    ? queryName_to_attributeName[key]
                    : key;
                if (key === 'fm') {
                    var $filter = $("#" + attributeName);
                    var $choice = $filter.find("input[val='" + val + "']");
                    $choice.prop('checked', true).change();
                    return;
                }
                var $select = getDropdownForAttr(attributeName);
                var validVal = typeof val !== "undefined" && val != "";
                var attributeSet = false;
                setSelectVal($select, val);
                if ($select.length === 1 && $select.attr("type") === "hidden") {
                    var $edit = $("#edit_" + $select.attr("id"));
                    console.log("edit " + $edit.attr("id"));
                    setSelectVal($edit, val);
                }
                if (context_1["default"].isMobile()) {
                    var $panel = getAttributePanelForAttr(attributeName);
                    if (!$panel.length) {
                        $panel = $("input:hidden[data-attribute-name=\"" + attributeName + "\"]").closest(".attribute-picker");
                    }
                    if ($panel.length) {
                        var $selected;
                        if (validVal) {
                            var decimalVal = parseFloat(val);
                            if (isNaN(decimalVal)) {
                                $selected = $panel.find(".option").filter(function (i, x) {
                                    return ($(x)
                                        .text()
                                        .trim() == val);
                                });
                            }
                            else {
                                $selected = $panel.find('.option[data-decimal="' + decimalVal + '"]');
                                if (!$selected.length && $panel.hasClass("attribute-picker")) {
                                    $selected = $panel.find('.asset[data-asset_id="' + decimalVal + '"]');
                                }
                            }
                            if (!$selected.length) {
                                $selected = $panel
                                    .find(".option .product-price-offer#" + val)
                                    .parent();
                            }
                            if ($selected.length) {
                                $selected.click();
                                attributeSet = true;
                            }
                        }
                    }
                }
                if (validVal && !attributeSet) {
                    $('input[type="hidden"][data-attribute-name="' + attributeName + '"]').val(val);
                    assetPicker_1.setupSelectedAttribute(attributeName);
                }
                if (attributeName == "formulaResult") {
                    priceFormula_1.initPriceSheetQuantity(val);
                }
                if (attributeName === "fabric2Id" && validVal) {
                    $("#second-fabric").prop("checked", true);
                    if (!context_1["default"].isMobile()) {
                        $("#matchingFabricSection").toggleClass("hidden", false);
                    }
                }
                if (attributeName === 'fabric2_CodeName') {
                    var $choice = $("#matchingFabricSection input[type=\"radio\"][value=\"" + val + "\"]");
                    if ($choice.length) {
                        $choice.prop('checked', true);
                    }
                }
            });
            $(".attribute-panel select").each(function (i, s) {
                var $sel = $(s);
                var $button = $sel.closest(".attribute-panel").prev(".attribute-button");
                $button
                    .find(".attribute-current")
                    .text($sel.find("option:checked").text());
            });
            $('.attribute-panel input[type="range"]').each(function (i, r) {
                var $panel = $(r).closest('.attribute-panel');
                var values = attributePanel_1.getPanelGroupValues($panel, 'width', 'height');
                attributePanel_1.onAttributePanelUpdate({ currentTarget: $panel[0] }, values.width + "\" W x " + values.height + "\" H");
            });
        }
    }
    exports.setAttributesFromHash = setAttributesFromHash;
    function setHashFromData(data) {
        var query = context_1["default"].getQuery();
        var noFabric2 = data["fabric2_CodeName"] == undefined;
        $.each(data, function (key, val) {
            if (noFabric2 && key.startsWith("fabric2")) {
                query = updateQueryWith(query, key, undefined);
            }
            else {
                if (key.startsWith("fabric2") && typeof val === "boolean") {
                    var val2 = val ? val : "0";
                    query = updateQueryWith(query, key, val2);
                }
                else {
                    query = updateQueryWith(query, key, val);
                }
            }
        });
        updateAddress(window.location.pathname, query, undefined, $("head title").text());
    }
    exports.setHashFromData = setHashFromData;
    function updateAddress(path, query, hash, title) {
        if (context_1["default"].supportHistory()) {
            window.history.replaceState(context_1["default"].getQuery(), title || $("title").text(), combineUrl(path) + querystring_1.formatQuery(query) + (hash || ""));
            $("form#product-details-page").attr("action", path);
            favorites_1.checkFavoriteSet();
        }
        else {
        }
    }
    exports.updateAddress = updateAddress;
    function combineUrl(path) {
        return window.location.protocol + "//" + window.location.host + path;
    }
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/addressBar.js
// module id = 26
// module chunks = 0